<div id="backdrop" (click)="requestClose()" (keydown.enter)="requestClose()"></div>
<div class="modal">
    <ng-content></ng-content>
</div>
